<template>
  <Dialog :visible="visible" class="irinox-dialog-dark" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '580px'}" :draggable="false"
              @update:visible="updateVisible" @show="show">
    
    <div v-if="mode!='confirm'" class="irinox-dialog-dark-content p-pt-5 p-pb-5">
      <img v-if="mode=='success'" src="assets/irinox/icons/success.svg" width="80" :alt="$t('common.success')"/>
      <img v-if="mode=='error'" src="assets/irinox/icons/error.svg" width="80" :alt="$t('common.error')" />
      <div class="p-pt-3 p-pb-3" v-html="message"></div>
    </div>

    <div v-else class="irinox-dialog-dark-content">
      <img :src="icon" width="80"  :alt="$t('common.confirm')"/>
      <div class="p-pt-3 p-pb-3" v-html="message"></div>
      <Button :label="leftB" @click="leftButtonClick"/>
      <Button :label="rightB" class="p-button-secondary" @click="rightButtonClick"/>
    </div>

    <template #footer>
    </template>
  </Dialog>
</template>

<script>
export default {
    emits: ['update:visible','click:left-button','click:right-button'],
    props: {
      visible: Boolean,
      mode: String,
      message: String,
      life: {
        type: Number,
        required: false,
        default: 0
      },
      icon: {
        type: String,
        required: false
      },
      leftB: {
        type: String,
        required: false
      },
      rightB: {
        type: String,
        required: false
      },
    },
    data() {
        return {
        };
    },
    methods: {
      updateVisible(value) {
        this.$emit("update:visible", value);
      },
      show() {
        if(this.life && this.life>0) {
          setTimeout(function() {
            this.$emit("update:visible", false);
          }.bind(this),this.life);
        }
      },
      leftButtonClick() {
        this.$emit("click:left-button");
      },
      rightButtonClick() {
        this.$emit("click:right-button");
      },
    }
}
</script>

<style>

.p-dialog.irinox-dialog-dark .p-dialog-header,
.p-dialog.irinox-dialog-dark .p-dialog-footer,
.p-dialog.irinox-dialog-dark .p-dialog-content {
  background: #002445;
  color: #FFFFFF;
}

.p-dialog.irinox-dialog-dark .irinox-dialog-dark-content {
  font-size: 35px;
  text-align: center;
}

.p-dialog.irinox-dialog-dark .p-button {
  border: 1px solid #FFFFFF;
  margin: 0 10px;
  width: fit-content;
  min-width: 200px;
}
.p-dialog.irinox-dialog-dark .more-than-2-buttons .p-button {
  width: 60%;
  min-width: 250px;
}

.p-dialog.irinox-dialog-dark .p-dialog-header-icons {
  position: absolute;
  right: 0.5rem;
}
.p-dialog.irinox-dialog-dark .p-dialog-header .p-dialog-header-icon {
  color: #FFFFFF;
}

</style>